import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3670c62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "annotation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentAnnotationForm = _resolveComponent("ContentAnnotationForm")!
  const _component_ContentAnnotationList = _resolveComponent("ContentAnnotationList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ContentAnnotationForm),
    _createVNode(_component_ContentAnnotationList)
  ]))
}